import React from "react";
import { Box } from "@mui/material";
import ReCaptcha from "react-google-recaptcha";

type IReCaptchaProps = {
  callback: (token: any) => void;
  sx?: any;
};

export const ReCaptchaComponent = ({ callback, sx }: IReCaptchaProps) => {
  return (
    <Box
      sx={{
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        ...sx,
      }}
    >
      <ReCaptcha
        sitekey={process.env.REACT_APP_CATPCHA_KEY}
        onChange={(token) => callback(token)}
      />
    </Box>
  );
};
